(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["address-update"] && !Shopify.designMode) return;
  try {
    
console.log('here');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index__instagram"] && !Shopify.designMode) return;
  try {
    
jQuery(document).ready(function($) {	

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["old-header"]) return;
  try {
    
//var a=['html','remove','location','href','https://www.flowers.ae/'];(function(c,d){var e=function(f){while(--f){c['push'](c['shift']());}};e(++d);}(a,0xf2));var b=function(c,d){c=c-0x0;var e=a[c];return e;};if(window[b('0x0')][b('0x1')]!=b('0x2')){jQuery(b('0x3'))[b('0x4')]();}

  } catch(e) { console.error(e); }
})();
})();
